<template>
  <!-- couponStatus -1 暂不可使用 0 可激活, 1 已使用  2 已过期 -->
  <div class="coupon-list">
    <div :key="index" class="coupon-item" v-for="(coupon, index) in list ">
      <div class="coupon-details">
        <!-- 距离失效倒计时 -->
        <count-down
          :time="coupon.expire_at | expiredCountdown"
          @finish="couponFinishHandler(coupon)"
          class="count-down"
          v-if="coupon.couponStatus === 0"
        />

        <!-- 距离生效倒计时 -->
        <count-down
          :time="coupon.effective_at | startCountDown"
          class="count-down"
          v-if="coupon.couponStatus === -1"
        />
        <div class="coupon-intro">
          <div
            :class="{'gray': coupon.couponStatus == 1 || coupon.couponStatus ==2}"
            class="coupon-img"
          >
            <img v-lazy="coupon.himg" />
          </div>
          <div class="coupon-desc">
            <div class="name van-multi-ellipsis--l2">{{coupon.title}}</div>
            <div class="time">{{coupon.effective_at | formatTime(coupon.expire_at)}}</div>
            <template v-if="coupon.couponStatus == 0 || coupon.couponStatus == -1">
              <button
                @click="activateHandler(coupon)"
                class="activation"
                v-show="useStatus(coupon.effective_at,coupon.expire_at, coupon.pickup_no)"
              >{{coupon.pop_ups_btn}}</button>
            </template>
          </div>
        </div>
        <div class="coupon-tips">{{coupon.content1}}</div>
        <div
          :class="{'status-used': coupon.couponStatus == 1, 'status-overdue': coupon.couponStatus ==2 }"
          class="coupon-status"
          v-if="coupon.couponStatus == 1 || coupon.couponStatus ==2"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { CountDown } from 'vant'
export default {
  name: 'coupon-list',
  components: {
    CountDown
  },
  props: {
    list: {
      type: Array
    }
  },
  computed: {
    useStatus (start, end, pickupNo) {
      return (start, end, pickupNo) => {
        const surTime = dayjs().diff(dayjs(start), 'ss')
        // const overdueTime = dayjs().diff(dayjs(end), 'ss')
        if (surTime > 0) {
          return true
        } else {
          return false
        }
      }
    }
  },
  filters: {
    formatTime (start, end) {
      return dayjs(start).format('YYYY.MM.DD') + ' - ' + dayjs(end).format('YYYY.MM.DD')
    },
    // 距可使用倒计时
    startCountDown (start) {
      const diffTime = dayjs(start).diff(dayjs())
      return diffTime > 0 ? diffTime : 0
    },
    // 距过期倒计时
    expiredCountdown (end) {
      return dayjs(end).diff(dayjs())
    }
  },
  methods: {
    // 激活事件通知
    async activateHandler (coupon) {
      this.$emit('activate-handler', coupon)
    },

    // 卡券失效通知
    couponFinishHandler (coupon) {
      console.log(1111)
      this.$emit('overdue-handler', coupon.pickup_no)
    },

    // 卡券生效通知
    couponStartHandler (coupon) {
      this.$emit('change', coupon.pickup_no)
    }
  }
}
</script>

<style lang="less" scoped>
.coupon-list {
  .coupon-details {
    position: relative;
    padding: 0.24rem;
    margin-top: 0.2rem;
    background-color: #fff;
    .coupon-intro {
      display: flex;
      align-items: center;
    }
    .coupon-img {
      width: 2rem;
      height: 1.4rem;
      margin-right: 0.2rem;
      img {
        object-fit: contain;
      }
    }
    .gray {
      img {
        -webkit-filter: grayscale(100%);
        -moz-filter: grayscale(100%);
        -ms-filter: grayscale(100%);
        -o-filter: grayscale(100%);
        filter: grayscale(100%);
        filter: gray;
      }
    }
    .coupon-desc {
      position: relative;
      width: 4.6rem;
      height: 1.4rem;
      .flex-column-between;
      .name {
        font-size: @fz26;
        color: @base;
      }
      .time {
        max-width: 3.2rem;
        font-size: @fz22;
        color: #6f6f6f;
      }
      .activation {
        position: absolute;
        bottom: 0;
        right: 0;
        min-width: 1rem;
        padding: 0.06rem 0.25rem;
        // height: 0.64rem;
        font-size: @fz28;
        color: #fff;
        background: linear-gradient(
          90deg,
          rgba(255, 147, 147, 1) 0%,
          rgba(255, 90, 90, 1) 100%
        );
        box-shadow: 0px 0.1rem 0.05rem -0.08rem rgba(255, 203, 203, 1);
        border-radius: 32px;
      }
    }
    .coupon-tips {
      position: relative;
      margin-top: 0.3rem;
      font-size: @fz22;
      color: #a8a8a8;
      border-top: 0.5px dotted #c9c9c9;
      padding-top: 0.22rem;
      padding-left: 0.2rem;
      text-align: left;
      &::after,
      &::before {
        content: "";
        position: absolute;
        width: 0.25rem;
        height: 0.25rem;
        background-color: #f6f6f6;
        border-radius: 50%;
        top: -0.125rem;
      }
      &::after {
        left: -0.35rem;
      }
      &::before {
        right: -0.35rem;
      }
    }
    .coupon-status {
      position: absolute;
      right: 0.15rem;
      bottom: 0.6rem;
      width: 1.57rem;
      height: 1.18rem;
    }
    .status-overdue {
      background: url("../../assets/img/coupon-center/overdue.png") center
        no-repeat;
      background-size: 100%;
    }
    .status-used {
      background: url("../../assets/img/coupon-center/used.png") center
        no-repeat;
      background-size: 100%;
    }
  }
  .count-down {
    display: none;
  }
}
</style>
